<ng-container *ngIf="selectedRowData">
  <dx-form
    id="form"
    [(formData)]="historyFormData"
    [colCount]="2"
    [showColonAfterLabel]="true"
    (onFieldDataChanged)="onFormChange($event)"
    [labelMode]="labelMode"
    [labelLocation]="labelLocation"
    [readOnly]="true"
  >
    <dxi-item itemType="group" [colSpan]="1">
      <dxi-item
        dataField="kayitAdi"
        [label]="{ text: 'Kayıt Adı' }"
        editorType="dxTextBox"
      ></dxi-item>
      <dxi-item
        dataField="kaydedenKod"
        [label]="{ text: 'Kaydeden Kişi' }"
        style="margin-top: 8px"
      >
        <div *dxTemplate>
          <dk-ctl-gen-kontrol
            [controlName]="'GenKullaniciArama'"
            [code]="historyFormData?.kaydedenKod"
            [labelText]="'Kaydeden Kişi'"
            [type]="'number'"
            [isReadOnly]="true"
            >
          </dk-ctl-gen-kontrol>
        </div>
      </dxi-item>
      <dxi-item
      dataField="sonDegistirenKod"
      [label]="{ text: 'Son Değiştiren' }"
      style="margin-top: 8px"
      >
        <div *dxTemplate>
          <dk-ctl-gen-kontrol
            [controlName]="'GenKullaniciArama'"
            [code]="historyFormData?.sonDegistirenKod"
            [labelText]="'Son Değiştiren'"
            [type]="'number'"
            [isReadOnly]="true"
          >
          </dk-ctl-gen-kontrol>
        </div>
      </dxi-item>
    </dxi-item>

    <dxi-item itemType="group" [colSpan]="1">
      <dxi-item
        dataField="Kod"
        [label]="{ text: 'Kayit Kod' }"
        editorType="dxNumberBox"
      ></dxi-item>
      <dxi-item
        dataField="kayitTarih"
        [label]="{ text: 'Kayit Tarih' }"
        editorType="dxDateBox"
      ></dxi-item>
      <dxi-item
        dataField="degisiklikTarih"
        [label]="{ text: 'Değişiklik Tarihi' }"
        editorType="dxDateBox"
      ></dxi-item>
    </dxi-item>
  </dx-form>
  <div style="display: flex; flex-flow: row">
    <ng-container
      class="grid-container"
      *ngIf="historyGridCtl$ | async as gridCtl"
    >
      <dk-dx-data-table2
        style="width: 50%"
        keyExpr="Kod"
        [tableTittle]="'Kayıt Bilgileri'"
        [height]="'59vh'"
        [dataSource]="dataSource"
        [columnList]="columnList"
        [gridCtlList]="gridCtl"
        (selectedRowData)="onSelectHistoryRow($event)"
        [columnTransactions]="false"
        [showBorders]="true"
      >
      </dk-dx-data-table2>
    </ng-container>
    <dx-scroll-view
      style="
        height: 56vh;
        width: 50%;
        border: 1px solid #dddddd;
        margin-top: 20px;
        overflow-x: auto;
      "
    >
      <!-- 12.10.2026 LOG_AUDIT: satır paket ya da doğrudan veritabanı kaynaklıysa (KAYNAK dolu) gösterilir -->
      <div *ngIf="kaynakMetni" class="kaynak-bilgisi">Kaynak: {{ kaynakMetni }}</div>
      <table class="veri-tablosu">
        <tr>
          <th class="table-header">
            <span *ngIf="!eskiDegerKolonu.length && !yeniDegerKolonu.length"
              >Kayıt Detayları</span
            ><span *ngIf="eskiDegerKolonu.length || yeniDegerKolonu.length"
              >Kolon Adı</span
            >
          </th>
          <th class="table-header" *ngIf="eskiDegerKolonu.length">
            Eski Değer
          </th>
          <th class="table-header" *ngIf="yeniDegerKolonu.length">
            Yeni Değer
          </th>
        </tr>
        <ng-container *ngIf="yeniDegerKolonu.length && !eskiDegerKolonu.length">
          <tr *ngFor="let item of yeniDegerKolonu">
            <td>{{ item.key }}</td>
            <td>{{ item.value }}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!yeniDegerKolonu.length && eskiDegerKolonu.length">
          <tr *ngFor="let item of eskiDegerKolonu">
            <td>{{ item.key }}</td>
            <td>{{ item.value }}</td>
          </tr>
        </ng-container>
        <!-- 12.10.2026: koşul eski && eski idi; silme satırlarında eski değerler iki kez listeleniyordu -->
        <!-- <ng-container *ngIf="eskiDegerKolonu.length && eskiDegerKolonu.length"> -->
        <ng-container *ngIf="eskiDegerKolonu.length && yeniDegerKolonu.length">
          <tr *ngFor="let item of eskiDegerKolonu; let i = index">
            <td>{{ item.key }}</td>
            <td>{{ item.value }}</td>
            <td>{{ yeniDegerKolonu[i]?.value }}</td>
          </tr>
        </ng-container>
      </table>
      <ng-container *ngIf="!HistoryRowSelected">
        <div style="width: 100%; text-align: center; margin-top: 26vh">
          Detay görmek için lütfen sol taraftan kayıt satırı seçiniz...
        </div>
      </ng-container>
    </dx-scroll-view>
  </div>
</ng-container>
